import AccelerateSection from './AccelerateSection'

export default AccelerateSection
